/* angular:styles/component:css;ab7cd2a3fe82818dce06b6c5b7066b6fe2426f705ba3d60cb16a516b10f09438;/src/src/app/shared/components/formly/input-serial-number-wrapper.ts */
.input-box-wrapper {
  border-bottom: 1px solid var(--ion-color-dark);
}
.input-box {
  border: 1px solid var(--ion-color-dark);
  border-bottom: 1px solid var(--ion-color-dark);
  border-radius: 2px;
  width: 100%;
  padding-left: 2px;
}
.input-box ion-item {
  --min-height: auto;
}
.disabled-field {
  pointer-events: none;
  opacity: 0.5;
}
.disabled-field ion-input,
.disabled-field ion-label {
  color: var(--ion-color-medium);
}
.text-center {
  text-align: center;
}
@media (max-width: 768px) {
  .text-center {
    text-align: --webkit-center;
  }
  .input-box {
    max-width: 90%;
  }
}
@media (max-width: 480px) {
  .input-box {
    max-width: 100%;
  }
}
/*# sourceMappingURL=input-serial-number-wrapper.css.map */
